export const LOAD_DEPARTMENTS = 'LOAD_DEPARTMENTS'
export const ADD_DEPARTMENT = 'ADD_DEPARTMENT'
export const DELETE_DEPARTMENT = 'DELETE_DEPARTMENT'
export const LOAD_DEPARTMENT = 'LOAD_DEPARTMENT'
export const LOAD_USERS =  'LOAD_USERS'